<template>
  <div>
    <img v-if="pc" :src="$t('events.img')" width="100%" />
    <img v-else :src="$t('events.imgm')" width="100%" />
    <div class="mw1200" :class="{mlr: !pc}" style="margin: 60px auto">
      <div class="h1_p">
        <h1 :class="{f36: !pc}">{{$t('events.h1')}}</h1>
        <p :class="{f20: !pc}" :style="{lineHeight: pc?'1.2':'30px'}" v-html="$t('events.p')"></p>
      </div>
      <div v-if="pc" style="display: flex;flex-wrap: wrap;justify-content: space-between">
        <div v-for="(item, index) in list" :key="index" style="margin-bottom: 50px;width: 22%">
          <img :src="`/acnImg/events/images/Event_${item.id}.jpg`" width="100%" style="margin-bottom: 20px;cursor: pointer" @click="vm(item)" />
          <div style="color: #00023d;font-size: 16px">{{isEn ? item.ename : item.cname}}</div>
          <div class="hover_red" @click="vm(item)" style="cursor: pointer;display:flex">
            <svg style="margin: 2px 5px 0 0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="17px">
              <path fill-rule="evenodd"  fill="rgb(170, 170, 170)" d="M-0.002,12.805 L8.390,12.805 L8.390,16.946 L16.001,8.945 L8.390,0.944 L8.390,5.085 L-0.002,5.085 L-0.002,12.805 Z"/>
            </svg>
            <div style="border-bottom: 1px #808080 solid">{{isEn?'View more pictures of the event':'项目现场的精彩回放'}}</div>
          </div>
        </div>
        <div v-for="i in (4 - list.length % 4)" :key="-i" style="width: 22%;margin-bottom: 50px"></div>
      </div>
      <div v-else style="display: flex;flex-wrap: wrap;justify-content: space-between">
        <div v-for="(item, index) in list" :key="index" style="margin-bottom: 50px;width: 48%">
          <img :src="`/acnImg/events/images/Event_${item.id}.jpg`" width="100%" style="margin-bottom: 20px;cursor: pointer" @click="vm(item)" />
          <div style="color: #00023d;font-size: 20px;line-height: 1">{{isEn ? item.ename : item.cname}}</div>
          <div @click="vm(item)" style="display:flex">
            <svg style="margin: 8px 5px 0 0" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="16px" height="17px">
              <path fill-rule="evenodd"  fill="rgb(170, 170, 170)" d="M-0.002,12.805 L8.390,12.805 L8.390,16.946 L16.001,8.945 L8.390,0.944 L8.390,5.085 L-0.002,5.085 L-0.002,12.805 Z"/>
            </svg>
            <div style="border-bottom: 1px #808080 solid;font-size: 20px">View more pictures of the event</div>
          </div>
        </div>
      </div>
    </div>
    <a-modal v-if="item" destroyOnClose v-model="visible" centered :footer="null" :bodyStyle="{padding: 0}" :maskStyle="{background: 'rgba(0,0,0,0.85)'}" :width="pc?900:'90%'">
      <a-carousel arrows dotsClass="dotsClass_event">
        <!--  eslint-disable-next-line vue/no-unused-vars-->
        <div slot="prevArrow" slot-scope="props" style="left: 0;top: calc(50% - 30px);margin-top: 0;width: 42px;height: 60px;z-index: 1">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="42px" height="60px">
            <image  x="0px" y="0px" width="42px" height="60px"  xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACoAAAA8CAQAAAC6ReBWAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkBAgBNDYEZ3FCAAACYElEQVRYw+3XT2jTUBwH8O/Ln/W/bbOx0f1x2D8oO1TUjVFFj3rwuHsvoog3GWjBgwcRpiAePMouohdPXsSbiAriWhiOTZF2HZXNWnFdsmarbfPHQ5abaRKS25LT94X3+/AIL3m/EJTg+kW5T3qoh3qohx5KlLFfQpOr47mhrvLix7sdl1bqpwrJC8MsFWLyky6tNEwX0smwliXFFZRj72QSAS33lMWaC+iYr5AZ9Gm5Iz+urIiO0VTgVibCarnVe1hebxvPtYhmwzfTPlrL252F8lan32xLaC56Pcke7JN6+3652es/3wJ6cTA/SREtV8WFiiibVZiicyNz43pe4x9t/FXMKkxQgvzopYQ+Wtp+UpNVK4+rD0qTG0dzQ/robWNx05LYD2XJfDIb00evtl7+sigaoyH6diod0bKK57U3f6yThuh8Uicl9Wn1A2+HNPxKZSJ6ev3TLmmIllt6ujx6PmYXpXHtf7dLwlSI8wEARaa5dq+y7wLaUz82U4ERPwAQnIzR6proGAUUfOIT7ERQG504wtHLu45RQEVRCBN9FxwLT/iKgrXt3wcFgC8tVZ6KankseDxQFCQLrgkKfNtrdbNRQgBg2J+NLPFdU9YUBdbb9f3TMZoAQHxgOlri24pjFNjsVMWZOEMBQISdja0ILdkxCjS6q8JMTDtQgszZ+NfdHckxCuxIy/yZaJABgAH6HLchNrqOUaAlf26eimonKkPNcvW20fFnq+1pSne/Vw/eLJa6Ytj22OylRPleeZXXMmNYa7tB6ygPqu9/95Q96Zlh20O8/30P9dBDif4DPDS+pN9tfcoAAAAASUVORK5CYII=" />
          </svg>
        </div>
        <!--  eslint-disable-next-line vue/no-unused-vars-->
        <div slot="nextArrow" slot-scope="props" style="right: 0;top: calc(50% - 30px);margin-top: 0;width: 41px;height: 60px">
          <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" width="41px" height="60px">
            <image  x="0px" y="0px" width="41px" height="60px"  xlink:href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAAA8CAQAAABRcltVAAAABGdBTUEAALGPC/xhBQAAACBjSFJNAAB6JgAAgIQAAPoAAACA6AAAdTAAAOpgAAA6mAAAF3CculE8AAAAAmJLR0QA/4ePzL8AAAAHdElNRQfkBAgBNyYy/TLlAAACZklEQVRYw+3XT2jTUBwH8G/+tGlr2iWdbLpOy2qrYnE4pBYRRY/ixZMXxYviQfAgHpzoxYMwheJNBPHSs3jzoDcVWir+gTIZ2JpR3R86tzZts5U2beIhza1NUtLTSC75/R7vfchL8t6PR+ArRnyRowYd0iEd0iF3KUn3bz7PXz3oJrObr1a66oie8np4D+0iz03MRzxDz2PAgI6i3ePcoxhLjYR8XZJ7aIR9fCToGoakcKtf82pLkBI8TQKA35Xk8rVG1yYJlNuLtQTHUADgo0/zS/VqxyYJVDs/xJNjPhoAGOpMcFkqt22SQKObq84F/C4AoMlksNxcadkkgaaSqcRZ3g0AFJHgpfbvpk0SaKuZatQ74QEAgjjBQVnatkkCHTUjTrtDPi07FmCJfMMmCajIiTw1w2pZ1D/l/lZX7ZEA8L1OqUcDWnzAF/XmRMUuCfyUduRZjgAATHqOs19EWbVJAsWdf805niQAIMgc9n2s9Os15D7zWXy3pscxf/8+Q5JnuUtTelwY8N1pqxgAXNx7LUzoL6GREmyTV/ZdDulxXkwJ8oD/yCJJ4Ob0hUk9y26++DO4gFgiKeJO+NS4nr1fT68ZFSQLpIe8NxPn9OzN37cbxv1NSZZ6ENWXoqKmSx+2zEaYkEHXw9h+rxbLykshWzOflSEZYuZj44wWt7rPi3nJHDQkD3nvx9hebWzIzwrmm68JOcvejTK9Cr7VWiisWigRhmRy7HbE1Vus680nvyoWq6MBeSOsg4K0UJQs13ADku6Bi2JquaVY54CBO1G6tN2RlU8bT4VhQYBwzuMO6ZC7mvwPtXS89RgB+UQAAAAASUVORK5CYII=" />
          </svg>
        </div>
        <img v-for="i in item.photo" :key="i" :src="`/acnImg/events/Event%20Pix/${item.id}/${i}.jpg`" width="100%" style="max-height: 600px" />
      </a-carousel>
      <div style="position: absolute;width: 100%;display: flex">
        <div style="width: 80%;border-top: 1px #eddc99 solid;margin-top: 10px;padding-top: 10px">
          <div :style="{fontSize: pc?'20px':'26px', lineHeight: pc?1.5:1.2}" style="color: #eddc99">{{isEn?item.ename:item.cname}}</div>
          <div :style="{fontSize: pc?'14px':'20px', lineHeight: pc?1.5:1}" style="color: #cccccc">{{item.date.substring(0,10)}} | {{isEn?item.eaddress:item.caddress}}</div>
        </div>
        <div style="background: #7F1F20;width: 20%;color: #eddc99;text-align: center;line-height: 73px;font-size: 20px">OUR EVENTS</div>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import request from '@/utils/request'
export default {
  name: 'Events',
  data () {
    return {
      list: [],
      visible: false,
      item: null
    }
  },
  computed: {
    ...mapGetters(['isEn', 'pc'])
  },
  methods: {
    async query () {
      this.list = await request.get('/events/list')
    },
    vm (item) {
      if (item.photo) {
        this.item = item
        this.visible = true
      }
    }
  },
  mounted () {
    this.query()
  }
}
</script>

<style lang="less">
  .dotsClass_event {
    text-align: center;
    list-style: none;
    position: absolute;
    bottom: 0;
    width: 100%;
    padding-left: 0;
    li {
      display: inline-block;
      margin: 0 5px;
      button {
        width: 10px;
        height: 10px;
        padding: 0;
        font-size: 0;
        border-radius: 50%;
        background: #D9D9D9;
        border: 0;
        cursor: pointer;
        outline: none;
      }
      &.slick-active button {
        background: #7F1F20;
      }
    }
  }

  .ant-modal-close-x {
    font-size: 50px;
    margin: 14px;
  }
</style>
